import PropTypes from 'prop-types';
import url from 'url';

import { bebop } from 'core/api/definitions/bebop';
import { ugc } from 'core/api/definitions/ugc';

const knownApis = {
  ugcApi: {
    path: '/ugc/api/v1',
    instance: ugc,
  },
  bebopApi: {
    path: '/api/v2',
    instance: bebop,
  },
};

export const knownApiContextTypes = Object.keys(knownApis).reduce((acc, name) => {
  acc[name] = PropTypes.object;
  return acc;
}, {});


const preferedScheme = 'https';

const throwError = msg => {
  throw new Error('[APIs Provider] ' + msg);
};

export default function coreApisFactory(params) {
  const {
    coreApisConfig,
    requestHeaders,
  } = params;

  return Object.keys(coreApisConfig).reduce((apis, apiName) => {
    if (!knownApis[apiName]) {
      return throwError(`'${apiName}' API is unknown.`);
    }

    const apiUrl = coreApisConfig[apiName];
    const resolvedUrl = apiUrl && apiUrl.indexOf('//') === 0
      ? `${preferedScheme}:${apiUrl}`
      : apiUrl;

    const instance = knownApis[apiName].instance;

    instance.client.defaults.baseURL = resolvedUrl
      || `${preferedScheme}://${requestHeaders.host}${knownApis[apiName].path}`;

    instance.addRequestParams && instance.addRequestParams(requestHeaders);

    if (
      process.env.NODE_RUNTIME
      && process.env.APP_ENV === 'production'
      && process.env.API_PROXY_URL
    ) {
      const descriptor = url.parse(process.env.API_PROXY_URL);

      instance.client.defaults.proxy = {
        protocol: descriptor.protocol,
        host: descriptor.hostname,
        port: descriptor.port,
      };
    }

    apis[apiName] = instance;
    return apis;
  }, {});
}
